import { foreignKey, jsonb, pgEnum, pgTable, uuid } from 'drizzle-orm/pg-core';
import { orgId, orgPrimaryKey, } from '../org-id';
import { relations, sql } from 'drizzle-orm';
import { Block } from '../block';
import { Profile } from '../profile';
import { Team } from '../roster/team';
import { isoTimestamp } from '../../utils';
export const ChangeType = pgEnum('change_type', [
    'exercise_added',
    'exercise_removed',
    'exercise_updated',
    'exercise_prescription_change',
    'assigned_date_changed',
    'tablet_exercise_added',
    'tablet_prescription_change',
    'tablet_exercise_updated',
    'tablet_exercise_removed',
]);
export const WorkoutChangeLog = pgTable('workout_change_log', {
    id: uuid('id').notNull(),
    orgId,
    createdAt: isoTimestamp('created_at').default(sql `now()`),
    createdById: uuid('created_by_id'),
    blockId: uuid('block_id').notNull(),
    workoutId: uuid('workout_id').notNull(),
    athleteId: uuid('athlete_id').notNull(),
    teamId: uuid('team_id').notNull(),
    changeType: ChangeType('change_type').notNull(),
    change: jsonb('change')
        .$type()
        .notNull()
        .default({}),
}, (table) => ({
    pk: orgPrimaryKey(table),
    blockFk: foreignKey({
        columns: [table.orgId, table.blockId],
        foreignColumns: [Block.orgId, Block.id],
    }),
    teamFk: foreignKey({
        columns: [table.orgId, table.teamId],
        foreignColumns: [Team.orgId, Team.id],
    }),
    athleteFk: foreignKey({
        columns: [table.orgId, table.athleteId],
        foreignColumns: [Profile.orgId, Profile.id],
    }),
}));
export const WorkoutChangeLog_Relations = relations(WorkoutChangeLog, ({ one }) => ({
    block: one(Block, {
        fields: [WorkoutChangeLog.orgId, WorkoutChangeLog.blockId],
        references: [Block.orgId, Block.id],
    }),
    team: one(Team, {
        fields: [WorkoutChangeLog.orgId, WorkoutChangeLog.teamId],
        references: [Team.orgId, Team.id],
    }),
    athlete: one(Profile, {
        fields: [WorkoutChangeLog.orgId, WorkoutChangeLog.athleteId],
        references: [Profile.orgId, Profile.id],
    }),
    publishedBy: one(Profile, {
        fields: [WorkoutChangeLog.orgId, WorkoutChangeLog.createdById],
        references: [Profile.orgId, Profile.id],
    }),
}));
//# sourceMappingURL=index.js.map